






























































































































import { Component, Vue } from "vue-property-decorator";
import * as util from "@/util";
import { domain, CompanyExtraDetails } from "@/domain";
import Upload from "@/components/Upload.vue";
import AvatarRef from "@/components/AvatarRef.vue";
import QuickSnack from "@/components/QuickSnack.vue";
import { resolveRefToURL } from "@/domain/fileStorage";

type LogoType = "vendor" | "receipt";

@Component({
  components: { Upload, AvatarRef, QuickSnack }
})
export default class CompanyEdit extends Vue {
  value = false;
  companyID = 0;
  loading = true;
  companyDetails: CompanyExtraDetails = this.emptyDetails(0);
  dirty = false;
  saving = false;
  saveDetails: CompanyExtraDetails = this.emptyDetails(0);

  logoPreviewDialog = false;
  logoPreview = { type: "vendor" as LogoType, logoRef: "", logoUrl: "" };

  get lang() {
    return this.$store.state.lang.data;
  }

  get receiptLogoRef() {
    return this.saveDetails.branding?.mobileReceiptLogo ?? this.companyDetails.branding?.mobileReceiptLogo;
  }

  get vendorLogoRef() {
    return this.saveDetails.branding?.mobileVendorLogo ?? this.companyDetails.branding?.mobileVendorLogo;
  }

  get snack(): QuickSnack {
    return this.$refs.snack as QuickSnack;
  }

  showCompanyID(companyID: number) {
    this.companyID = companyID;
    this.companyDetails = this.emptyDetails(companyID);
    this.resetSaveDetails();
    this.value = true;
    this.loadCompanyData();
  }

  async loadCompanyData() {
    try {
      this.loading = true;
      this.companyDetails = await domain.backend.getCompanyDetails(this.companyID);
      this.resetSaveDetails();
    } catch (err) {
      this.snack.show(this.lang.errorLoadingData, "error");
      util.logError("Error cargando datos", err);
    }
    this.loading = false;
  }

  emptyDetails(companyID: number) {
    return {
      companyID,
      branding: {
        mobileVendorLogo: null,
        mobileReceiptLogo: null
      }
    };
  }

  resetSaveDetails() {
    this.saveDetails = this.emptyDetails(this.companyID);
    this.dirty = false;
    this.saving = false;
  }

  async cmdSave() {
    if (this.dirty) {
      try {
        this.saving = true;
        await domain.backend.saveCompanyDetails(this.saveDetails);
        await this.loadCompanyData();
      } catch (err) {
        this.snack.show(this.lang.errorLoadingData, "error");
        util.logError("Error cargando datos", err);
      }
      this.saving = false;
    }
  }

  cmdRemoveLogo(type: LogoType) {
    this.setLogo(type, "");
  }

  uploadFailed(err: unknown) {
    this.snack.show(this.lang.errorUploadingFile, "error");
    util.logError("Error subiendo archivo", err);
  }

  uploadReceiptLogoSuccess(newFileRef: string) {
    this.setLogo("receipt", newFileRef);
  }

  uploadVendorLogoSuccess(newFileRef: string) {
    this.setLogo("vendor", newFileRef);
  }

  setLogo(type: LogoType, logoRef: string) {
    this.dirty = true;
    const branding = this.saveDetails.branding || {
      mobileVendorLogo: null,
      mobileReceiptLogo: null
    };
    if (type == "vendor") {
      branding.mobileVendorLogo = logoRef;
    } else {
      branding.mobileReceiptLogo = logoRef;
    }
    this.saveDetails.branding = branding;
  }

  async cmdOpenPreview(type: LogoType) {
    this.logoPreview = {
      type,
      logoRef: (type == "vendor" ? this.vendorLogoRef : this.receiptLogoRef) || "",
      logoUrl: type == "vendor" ? "" : await resolveRefToURL(this.receiptLogoRef || "")
    };
    this.logoPreviewDialog = !!this.logoPreview.logoRef;
  }
}
